import $ from 'jquery';

export function init() {
  // Looping thru every table inside 'main .user-content'
  $('main .user-content table').each(function() {
    const $table = $(this);
    const headers = [];

    // Collect all table headers' text and order into an array
    $table.find('thead tr th').each(function() {
      headers.push($(this).text().trim());
    });

    // Looping thru every body row
    $table.find('tbody tr').each(function() {
      // Looping thru every cell in this specific row
      $(this).find('td').each(function(index) {
        // Get the matching header text using the current cell's index
        const headerText = headers[index];

        // Set the data-label attribute to the matching header if it exists
        if (headerText) {
          $(this).attr('data-label', headerText);
        }
      });
    });
  });
}